import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles.css';
import './cathedris.css';
import './cathedris-layout.css';

const root = document.getElementById('root');

if (!root) throw new Error('Cathedris could not find its root element.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Offline support is progressive enhancement; the game remains fully playable online.
    });
  });
}
